"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiException = void 0;
/**
 *
 * @export
 * @class ApiException
 * @extends {Error}
 */
class ApiException extends Error {
    /**
     *
     *
     * @param {string} message
     * @param {*} [data]
     * @memberof ApiException
     */
    constructor(message, data) {
        super(message);
        this.data = data;
    }
    /**
     * Ritorna i dati della risposta http
     *
     * @returns {*}
     * @memberof ApiException
     */
    getData() {
        return this.data;
    }
}
exports.ApiException = ApiException;
